const navbarKeys = {
  english: [
    "Experiences",
    "Education",
    "Courses",
    "Projects",
    "Volunteering",
    "extra-info",
  ],
  arabic: [
    "الخبرات",
    "التعليم",
    "الدورات",
    "المشاريع",
    "التطوع",
    "معلومات اضافية",
  ],
};

export default navbarKeys;
